export const REGEX_EMAIL = new RegExp(/\S+@\S+\.[\S+]{2,}/);

export const RING_SKU_PREFIX = "TG-RING";

export const newRingSku = {
  NEW_RING6: "TG-2RING6",
  NEW_RING7: "TG-2RING7",
  NEW_RING8: "TG-2RING8",
  NEW_RING9: "TG-2RING9",
  NEW_RING10: "TG-2RING10",
  NEW_RING11: "TG-2RING11",
  NEW_RING12: "TG-2RING12",
  NEW_RING13: "TG-2RING13",
};

export const ringSku = {
  RING6: "TG-2RING6",
  RING7: "TG-2RING7",
  RING8: "TG-RING8",
  RING9: "TG-RING9",
  RING10: "TG-RING10",
  RING11: "TG-RING11",
  RING12: "TG-RING12",
  RING13: "TG-RING13",
};

export const newRingSkuToOldKey = {
  "TG-2RING6": "RING6",
  "TG-2RING7": "RING7",
  "TG-2RING8": "RING8",
  "TG-2RING9": "RING9",
  "TG-2RING10": "RING10",
  "TG-2RING11": "RING11",
  "TG-2RING12": "RING12",
  "TG-2RING13": "RING13",
} as const;

export const getSizeBySku = (sku: string) =>
  ringSizes[sku] ??
  ringSizes[
    ringSku[newRingSkuToOldKey[sku as keyof typeof newRingSkuToOldKey]]
  ];

export const ringSizes = {
  [ringSku.RING6]: {
    id: ringSku.RING6,
    us: 6,
    eu: 51,
    mm: 16.51,
    available: true,
  },
  [ringSku.RING7]: {
    id: ringSku.RING7,
    us: 7,
    eu: 55,
    mm: 17.35,
    available: true,
  },
  [ringSku.RING8]: {
    id: ringSku.RING8,
    us: 8,
    eu: 57,
    mm: 18.19,
    available: true,
  },
  [ringSku.RING9]: {
    id: ringSku.RING9,
    us: 9,
    eu: 59,
    mm: 18.89,
    available: true,
  },
  [ringSku.RING10]: {
    id: ringSku.RING10,
    us: 10,
    eu: 61.5,
    mm: 19.84,
    available: true,
  },
  [ringSku.RING11]: {
    id: ringSku.RING11,
    us: 11,
    eu: 64,
    mm: 20.68,
    available: true,
  },
  [ringSku.RING12]: {
    id: ringSku.RING12,
    us: 12,
    eu: 68,
    mm: 21.49,
    available: true,
  },
  [ringSku.RING13]: {
    id: ringSku.RING13,
    us: 13,
    eu: 70,
    mm: 22.33,
    available: true,
  },
};

export const SENTRY_ERROR_MESSAGE_CART_CREATE = "Failed to create cart";
